import React from 'react';
 import Icon from'@/components/ui/AppIcon';

interface Certification {
  id: string
  name: string
  description: string
  iconName: string
  details: string
}

const CertificationsSection: React.FC = () => {
  const certifications: Certification[] = [
    {
      id: 'kimberley',
      name: 'Kimberley Process',
      description: 'Certified conflict-free gold export',
      iconName: 'CheckBadgeIcon',
      details: 'Full compliance with international conflict-free gold standards',
    },
    {
      id: 'lbma',
      name: 'LBMA Certified',
      description: 'Good Delivery List Member',
      iconName: 'ShieldCheckIcon',
      details: 'London Bullion Market Association accredited refiner',
    },
    {
      id: 'iso',
      name: 'ISO 9001:2015',
      description: 'Quality Management System',
      iconName: 'StarIcon',
      details: 'International standard for quality management excellence',
    },
  ]

  return (
    <section className="py-24 md:py-32 px-6 md:px-12 bg-card border-t border-border">
      <div className="w-full max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <span className="text-xs font-body font-bold uppercase tracking-[0.4em] text-muted-foreground mb-4 block">
            Trust & Compliance
          </span>
          <h2 className="text-5xl md:text-6xl font-display font-bold tracking-tight text-foreground mb-4">
            Internationally Certified
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            Full compliance with global gold trading standards and regulations.
          </p>
        </div>

        {/* Certification Cards with Stagger Animation */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 stagger-children">
          {certifications.map((cert, index) => (
            <div
              key={cert.id}
              className="group glass-card p-8 rounded-3xl border border-border shadow-lg hover:shadow-2xl transition-smooth hover:-translate-y-3 hover:scale-105 cursor-pointer relative overflow-hidden reveal"
              style={{ animationDelay: `${0.1 + index * 0.1}s` }}
            >
              {/* Shimmer Effect */}
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-primary/10 to-transparent pointer-events-none group-hover:animate-shimmer-effect"></div>

              <div className="relative z-10">
                {/* Icon with Enhanced Animation */}
                <div className="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary transition-smooth group-hover:scale-110 group-hover:rotate-12">
                  <Icon
                    name={cert.iconName as any}
                    size={32}
                    className="text-primary group-hover:text-primary-foreground transition-smooth group-hover:scale-110"
                  />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-display font-bold text-foreground mb-2 group-hover:text-primary transition-smooth">
                  {cert.name}
                </h3>
                <p className="text-base font-body text-muted-foreground mb-4">
                  {cert.description}
                </p>

                {/* Details (Visible on Hover) with Smooth Fade */}
                <div className="opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-20 transition-all duration-500 overflow-hidden">
                  <div className="h-[1px] w-full bg-border mb-4"></div>
                  <p className="text-sm font-body text-muted-foreground leading-relaxed">
                    {cert.details}
                  </p>
                </div>

                {/* Gold Border Accent */}
                <div className="absolute top-0 left-0 w-full h-1 bg-primary opacity-0 group-hover:opacity-100 transition-smooth rounded-t-3xl"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Metrics with Enhanced Hover */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto reveal">
          <div className="glass-card p-8 rounded-2xl border border-border text-center hover-lift hover-glow transition-smooth cursor-pointer">
            <div className="text-5xl font-display font-bold text-foreground mb-2 hover:text-primary transition-smooth">500+</div>
            <p className="text-base font-body text-muted-foreground">
              International Shipments Completed
            </p>
          </div>
          <div className="glass-card p-8 rounded-2xl border border-border text-center hover-lift hover-glow transition-smooth cursor-pointer">
            <div className="text-5xl font-display font-bold text-foreground mb-2 hover:text-primary transition-smooth">2018</div>
            <p className="text-base font-body text-muted-foreground">
              Operating Since • Trusted Partner
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CertificationsSection